"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _Tabs = _interopRequireDefault(require("../../Tabs"));
var _elements = _interopRequireDefault(require("./elements"));
var _excluded = ["children", "tabDefinitions", "tabCreator", "selected", "ariaLabel", "onChange", "variant", "maxRowItemCount", "orientation", "widthLineTabEnd", "bottomLineTabEnd", "leftLineTabEnd", "color"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var PageHeaderTabs = function PageHeaderTabs(_ref) {
  var children = _ref.children,
    tabDefinitions = _ref.tabDefinitions,
    tabCreator = _ref.tabCreator,
    selected = _ref.selected,
    ariaLabel = _ref.ariaLabel,
    onChange = _ref.onChange,
    variant = _ref.variant,
    maxRowItemCount = _ref.maxRowItemCount,
    orientation = _ref.orientation,
    widthLineTabEnd = _ref.widthLineTabEnd,
    bottomLineTabEnd = _ref.bottomLineTabEnd,
    leftLineTabEnd = _ref.leftLineTabEnd,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_elements["default"], {
    position: "fixed",
    className: "withPageHeader",
    color: color
  }, /*#__PURE__*/_react["default"].createElement(_material.Paper, _extends({
    square: true,
    elevation: 0
  }, props), /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    tabDefinitions: tabDefinitions,
    tabCreator: tabCreator,
    selected: selected,
    ariaLabel: ariaLabel,
    onChange: onChange,
    variant: variant,
    maxRowItemCount: maxRowItemCount,
    orientation: orientation,
    widthLineTabEnd: widthLineTabEnd,
    bottomLineTabEnd: bottomLineTabEnd,
    leftLineTabEnd: leftLineTabEnd
  }, children)));
};
PageHeaderTabs.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  tabDefinitions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  tabCreator: _propTypes["default"].func,
  selected: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  ariaLabel: _propTypes["default"].string.isRequired,
  variant: _propTypes["default"].string,
  maxRowItemCount: _propTypes["default"].number,
  orientation: _propTypes["default"].string,
  widthLineTabEnd: _propTypes["default"].string,
  bottomLineTabEnd: _propTypes["default"].string,
  leftLineTabEnd: _propTypes["default"].string,
  color: _propTypes["default"].string
};
PageHeaderTabs.defaultProps = {
  children: [],
  tabDefinitions: [],
  tabCreator: function tabCreator() {},
  variant: 'fullWidth',
  maxRowItemCount: 5,
  orientation: 'horizontal',
  widthLineTabEnd: '100%',
  bottomLineTabEnd: '0',
  leftLineTabEnd: '0',
  color: 'default'
};
var _default = exports["default"] = PageHeaderTabs;